module.exports = __webpack_public_path__ + "img/app.4d8073a6.webp";